import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AgGridModule } from '@ag-grid-community/angular';
import { PageTitleModule } from 'app/layout/components/page-title/page-title.module';
import { AccountingComponent } from 'app/main/accounting/accounting.component';
import { MaterialModule } from 'app/main/material.module';
import { MomentModule } from 'ngx-moment';
import { AccountingEffects } from './accounting.effects';
import * as fromAccounting from './accounting.reducer';
import { AccountingResolver } from './accounting.resolver';

@NgModule({
    declarations: [AccountingComponent],
    imports: [
        FuseSharedModule,
        MaterialModule,
        PageTitleModule,

        // AG Grid
        AgGridModule.withComponents([]),

        MomentModule,
        StoreModule.forFeature('accounting', fromAccounting.reducer),
        EffectsModule.forFeature([AccountingEffects])
    ],
    exports: [AccountingComponent],
    providers: [AccountingResolver]
})
export class AccountingModule {}
